/** Every word the public apply form says, in both languages.
 *
 *  English is the source. The Hindi is a first translation and is **marked for review** on the
 *  privacy page, because a consent sentence that is slightly wrong in the language the applicant
 *  actually reads is the one thing here that must not be guessed at.
 */
export const COPY = {
  hi: {
    switchTo: "English",
    title: "goSTOPS में नौकरी",
    subtitle: "2 मिनट का फ़ॉर्म भरें — HR टीम 2–3 दिन में कॉल करेगी",
    name: "आपका नाम",
    namePlaceholder: "पूरा नाम",
    phone: "मोबाइल नंबर",
    phonePlaceholder: "10 अंकों का नंबर",
    role: "कौन सा काम?",
    experience: "कितना अनुभव?",
    pincode: "आपका पिनकोड",
    pincodePlaceholder: "6 अंक",
    dontKnow: "पिनकोड नहीं पता",
    city: "शहर का नाम",
    cityPlaceholder: "जैसे: इंदौर",
    branch: "कौन सी जगह पर काम चाहिए?",
    anyBranch: "कोई भी जगह",
    openingSoon: "जल्द खुल रहा है",
    languages: "कौन सी भाषाएँ बोलते हैं?",
    salary: "कितनी सैलरी चाहिए? (महीने की)",
    salaryPlaceholder: "जैसे: 15000 — वैकल्पिक",
    consent: "मैं सहमत हूँ कि goSTOPS मुझे नौकरी के बारे में कॉल, WhatsApp या SMS पर संपर्क कर सकता है और मेरी जानकारी 12 महीने तक रख सकता है। मैं कभी भी रोकने या जानकारी हटाने के लिए कह सकता हूँ।",
    privacy: "प्राइवेसी नोटिस पढ़ें",
    submit: "फ़ॉर्म भेजें",
    sending: "भेज रहे हैं…",
    required: "यह ज़रूरी है",
    thanksTitle: "धन्यवाद!",
    thanksBody: "HR टीम 2–3 दिन में आपसे संपर्क करेगी।",
    thanksNote: "अपना फ़ोन चालू रखें। goSTOPS की तरफ़ से कॉल या WhatsApp आएगा।",
    another: "कोई और फ़ॉर्म भरें",
    closedTitle: "आवेदन जल्द शुरू होंगे",
    closedBody: "यह फ़ॉर्म अभी तैयार हो रहा है। कृपया थोड़ी देर बाद कोशिश करें।",
    consentMissing: "आगे बढ़ने के लिए सहमति ज़रूरी है",
    phoneBad: "10 अंकों का मोबाइल नंबर डालें",
    nameBad: "अपना नाम लिखें",
    roleBad: "काम चुनें",
    failed: "फ़ॉर्म नहीं भेजा जा सका। दोबारा कोशिश करें।",
  },
  en: {
    switchTo: "हिंदी",
    title: "Jobs at goSTOPS",
    subtitle: "A 2-minute form — our HR team calls within 2–3 days",
    name: "Your name",
    namePlaceholder: "Full name",
    phone: "Mobile number",
    phonePlaceholder: "10-digit number",
    role: "What work are you looking for?",
    experience: "How much experience?",
    pincode: "Your pincode",
    pincodePlaceholder: "6 digits",
    dontKnow: "I don't know my pincode",
    city: "Your city",
    cityPlaceholder: "e.g. Indore",
    branch: "Where would you like to work?",
    anyBranch: "Any location",
    openingSoon: "opening soon",
    languages: "Which languages do you speak?",
    salary: "Expected monthly salary",
    salaryPlaceholder: "e.g. 15000 — optional",
    consent: "I agree that goSTOPS may contact me about jobs by call, WhatsApp or SMS and keep my details for 12 months. I can ask to stop or delete them anytime.",
    privacy: "Read the privacy notice",
    submit: "Send my form",
    sending: "Sending…",
    required: "Required",
    thanksTitle: "Thank you!",
    thanksBody: "Our HR team will contact you in 2–3 days.",
    thanksNote: "Keep your phone handy — the call or WhatsApp will come from goSTOPS.",
    another: "Fill another form",
    closedTitle: "Applications open soon",
    closedBody: "This form is still being set up. Please try again a little later.",
    consentMissing: "The consent tick is required",
    phoneBad: "Enter a 10-digit mobile number",
    nameBad: "Please enter your name",
    roleBad: "Pick the work you are looking for",
    failed: "Could not send the form. Please try again.",
  },
};

export const PRIVACY = {
  en: {
    review: null,
    title: "Privacy notice — job applications",
    updated: "What goSTOPS does with the details you send on the apply form.",
    sections: [
      ["Why we ask", "We use your details for one purpose only: to contact you about jobs at goSTOPS and to take your application forward. We do not sell them, we do not share them with anybody outside goSTOPS, and we do not use them for marketing."],
      ["What we collect", "Your name, mobile number, the kind of work you are looking for, your experience, your pincode or city, the languages you speak, the branch you prefer, and the salary you expect if you tell us. Nothing else — there is no document upload and no payment on this form."],
      ["How long we keep it", "12 months from the last time you were active with us — the last application, call or message. After that your details are deleted. If you apply again, the 12 months start again from that day."],
      ["How to stop or delete", "Tell us and we stop. Reply STOP to any WhatsApp or SMS from us, say so on a call, or write to the contact below. We will stop contacting you, and delete your details if you ask us to."],
      ["Who to write to", "The grievance contact below is the person at goSTOPS responsible for this. They answer questions about your details and handle requests to stop or delete."],
    ],
  },
  hi: {
    review: "अनुवाद — समीक्षा के लिए (translation — for review)",
    title: "प्राइवेसी नोटिस — नौकरी के आवेदन",
    updated: "आप फ़ॉर्म में जो जानकारी देते हैं, goSTOPS उसका क्या करता है।",
    sections: [
      ["हम क्यों पूछते हैं", "आपकी जानकारी का इस्तेमाल सिर्फ़ एक काम के लिए होता है: goSTOPS में नौकरी के बारे में आपसे संपर्क करना और आपका आवेदन आगे बढ़ाना। हम इसे बेचते नहीं हैं, goSTOPS के बाहर किसी को देते नहीं हैं, और मार्केटिंग के लिए इस्तेमाल नहीं करते।"],
      ["हम क्या लेते हैं", "आपका नाम, मोबाइल नंबर, आप कौन सा काम चाहते हैं, अनुभव, पिनकोड या शहर, कौन सी भाषाएँ बोलते हैं, पसंदीदा जगह, और अगर आप बताएँ तो अपेक्षित सैलरी। इससे ज़्यादा कुछ नहीं — इस फ़ॉर्म में कोई डॉक्यूमेंट या पैसा नहीं लगता।"],
      ["कितने समय तक रखते हैं", "आपकी आख़िरी गतिविधि (आवेदन, कॉल या मैसेज) से 12 महीने तक। उसके बाद जानकारी हटा दी जाती है। दोबारा आवेदन करने पर 12 महीने उस दिन से नए सिरे से शुरू होते हैं।"],
      ["रोकना या हटाना कैसे है", "हमें बता दें, हम रोक देंगे। हमारे किसी WhatsApp या SMS पर STOP लिखकर भेजें, कॉल पर कह दें, या नीचे दिए पते पर लिखें। हम संपर्क बंद कर देंगे, और कहने पर आपकी जानकारी हटा देंगे।"],
      ["किसे लिखें", "नीचे दिया गया शिकायत संपर्क goSTOPS में इसके लिए ज़िम्मेदार व्यक्ति है। आपकी जानकारी से जुड़े सवाल और रोकने/हटाने की माँग वही देखते हैं।"],
    ],
  },
};
